import React from 'react'
import './articles.css'
const Banks = () => {
  return (
    <div class="articlecontainer">
    <h1>How to Open a Corporate Bank Account in Albania</h1>
    <p>Opening a corporate bank account is a mandatory step when establishing a business in Albania. It enables businesses to receive payments, make transactions, and comply with tax regulations.</p>
    <div class="note">
        <strong>Legal Obligation:</strong> Businesses must register their bank account details with the tax authorities within 20 calendar days of business registration to avoid penalties.
    </div>
    <h2>Choosing an Albanian Bank</h2>
    <table>
        <tr>
            <th>Bank Name</th>
            <th>Corporate Banking Features</th>
            <th>Website</th>
        </tr>
        <tr>
            <td>BKT</td>
            <td>Business accounts, online banking, multiple currency options</td>
            <td><a href="https://www.bkt.com.al" target="_blank">Visit</a></td>
        </tr>
        <tr>
            <td>Credins Bank</td>
            <td>Business loans, multi-currency accounts, online banking</td>
            <td><a href="https://www.bankacredins.com" target="_blank">Visit</a></td>
        </tr>
        <tr>
            <td>Raiffeisen Bank</td>
            <td>International banking services, corporate cards, loans</td>
            <td><a href="https://www.raiffeisen.al" target="_blank">Visit</a></td>
        </tr>
    </table>
    
    <h2>Step-by-Step Guide to Opening a Corporate Bank Account</h2>
    <h3>Step 1: Choose the Right Bank for Your Business</h3>
    <ul>
        <li>Consider fees, online banking services, and foreign currency account options.</li>
        <li>Some banks require proof of local address for non-residents.</li>
    </ul>
    
    <h3>Step 2: Gather the Required Documents</h3>
    <strong>For Albanian Business Owners:</strong>
    <ul>
        <li>Business Registration Certificate (NIPT/NUIS)</li>
        <li>Statute and Act of Establishment</li>
        <li>Administrator’s ID or Passport</li>
    </ul>
    <strong>For Foreign Business Owners:</strong>
    <ul>
        <li>Residence Permit (if applicable)</li>
        <li>Proof of Local Address (utility bill, rental contract)</li>
        <li>Notarized and Translated Foreign Documents</li>
    </ul>
    
    <h3>Step 3: Deposit the Minimum Required Capital</h3>
    <ul>
        <li>LLCs: 100 ALL (~€1)</li>
        <li>JSCs: 1,000,000 ALL (~€10,000)</li>
    </ul>
    
    <h3>Step 4: Sign the Bank Agreement & Activate Online Banking</h3>
    <ul>
        <li>Sign the corporate banking agreement.</li>
        <li>Activate online banking and corporate cards.</li>
        <li>Register your bank account with tax authorities within 20 days.</li>
    </ul>
    
    <h2>Final Thoughts</h2>
    <p>Foreign entrepreneurs should verify residency and address requirements before selecting a bank. Corporate accounts typically take 2-5 working days to be fully operational.</p>
</div>
  )
}

export default Banks